const normalizeName = (name) => name?.trim().toLowerCase() ?? "";

export const OPERATIVE_MENU_GROUPS = [
	[
		"Airflow Dashboard",
		"DAG Monitoring",
		"Positions",
		"Map",
		["Customer Simulation", "Coverage Simulation"],
	],
	["System Anomalies", "Case Anomalies"],
	["Black & White Lists", "Import File Monitoring"],
];

export const HISTORY_MENU_ITEMS = [
	"Sales Orders",
	"Work Orders",
	"Workflows",
	"Events",
	"Logs",
];

const buildDashboardLookup = (dashboards) => {
	const byName = new Map();

	dashboards.forEach((dashboard) => {
		byName.set(normalizeName(dashboard.name), dashboard);
	});

	return byName;
};

const toAliases = (nameOrAliases) =>
	Array.isArray(nameOrAliases) ? nameOrAliases : [nameOrAliases];

const resolveDashboard = (dashboardByName, aliases, assignedNames) => {
	for (const alias of aliases) {
		const dashboard = dashboardByName.get(normalizeName(alias));
		if (dashboard && !assignedNames.has(normalizeName(dashboard.name))) {
			assignedNames.add(normalizeName(dashboard.name));
			return dashboard;
		}
	}

	return null;
};

export const partitionOperativeDashboards = (dashboards) => {
	const dashboardByName = buildDashboardLookup(dashboards);
	const assignedNames = new Set();

	const operativeGroups = OPERATIVE_MENU_GROUPS.map((group) =>
		group
			.map((nameOrAliases) =>
				resolveDashboard(
					dashboardByName,
					toAliases(nameOrAliases),
					assignedNames
				)
			)
			.filter(Boolean)
	).filter((group) => group.length > 0);

	const historyDashboards = HISTORY_MENU_ITEMS.map((name) => {
		const dashboard = dashboardByName.get(normalizeName(name));
		if (dashboard) {
			assignedNames.add(normalizeName(name));
		}
		return dashboard ?? null;
	}).filter(Boolean);

	const uncategorized = dashboards.filter(
		(dashboard) => !assignedNames.has(normalizeName(dashboard.name))
	);

	return { operativeGroups, historyDashboards, uncategorized };
};
